import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteFornecedorCadastro } from '../service';
import {
  DELETE_FORNECEDOR_CADASTRO,
  DELETE_FORNECEDOR_CADASTRO_PENDING,
  DELETE_FORNECEDOR_CADASTRO_SUCCESS,
  DELETE_FORNECEDOR_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteFornecedorCadastro(action) {
  yield put({ type: DELETE_FORNECEDOR_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.FORNECEDOR_EXCLUIR);

  try {
    const a = yield call(deleteFornecedorCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_FORNECEDOR_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_FORNECEDOR_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se o fornecedor não está vinculado em outra movimentação no sistema...');
  }
}

export default function* watchDeleteFornecedorCadastro() {
  yield takeLatest(DELETE_FORNECEDOR_CADASTRO, sagaDeleteFornecedorCadastro)
}
